import { Button } from "@admin/components/atoms/Button";
import { DataTable, DataTableColumn } from "@admin/components/molecules/Table";
import useFoodManagementModals from "@admin/hooks/useFoodManagementModals";
import {
  CompanyLocation,
  dateToISO,
  FoodControlPoint,
  FoodControlPointInstance,
  FoodManagementControls,
  InstanceStatus,
  useControlPointTypeTranslations,
} from "@enos-monorepo/lib";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { CleaningFloorAndHoodModal } from "../Modals/CleaningFloorAndHoodModal";

interface NonPeriodicCheckTableProps {
  selectedLocation?: CompanyLocation;
  companyId?: string;
  controlPoints?: FoodControlPoint[];
}

export function GeneralCleaningControls({
  selectedLocation,
  companyId,
  controlPoints,
}: NonPeriodicCheckTableProps) {
  const [currentInstance, setCurrentInstance] =
    useState<FoodControlPointInstance>();

  const { t } = useTranslation();
  const { openModal, closeModals, modalOpen } = useFoodManagementModals();
  const controlPointTypeTranslations = useControlPointTypeTranslations();

  const columns: DataTableColumn<FoodControlPoint>[] = [
    {
      id: "name",
      accessorKey: "name",
      cell: (row) => {
        return controlPointTypeTranslations[row.row.original.type];
      },
    },
    {
      id: "Actions",
      accessorKey: "actions",
      size: 120,
      cell: (row) => {
        return (
          <Button size="sm">
            <i className="ki-outline ki-plus-squared"></i> {t("food.Entry")}
          </Button>
        );
      },
    },
  ];

  const handleCellClick = useCallback(
    (row: FoodControlPoint) => {
      if (companyId && selectedLocation) {
        setCurrentInstance({
          foodControlPointId: row.id,
          // 1 week before params.date
          startDate: dateToISO(
            new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
          ),
          endDate: dateToISO(new Date()),
          updatedDate: dateToISO(new Date()),
          status: InstanceStatus.empty,
          companyId: companyId,
          companyLocationId: selectedLocation.id,
        });
        openModal(row.type);
      }
    },

    [companyId, openModal, selectedLocation],
  );

  return (
    <div className="flex flex-col gap-7.5">
      <DataTable
        columns={columns}
        data={controlPoints}
        title={t("food.Cleaning Non Periodic Controls")}
        showHeadRow={false}
        isInfoIcon={false}
        onRowClick={handleCellClick}
      />

      <CleaningFloorAndHoodModal
        open={modalOpen.cleaningFloor}
        type={FoodManagementControls.cleaningFloor}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
      <CleaningFloorAndHoodModal
        open={modalOpen.cleaningHood}
        type={FoodManagementControls.cleaningHood}
        onClose={closeModals}
        foodControlPointInstance={currentInstance}
      />
    </div>
  );
}
